// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desk-header {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  background-color: #fff;
  color: #fff;
}
.desk-header .pagos-cont {
  width: 100%;
  height: 6em;
  background-color: #ecd6d4;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.desk-header .pagos-cont .first-cont {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.desk-header .pagos-cont .first-cont .txt-cont {
  width: 20em;
  height: 3.5em;
  background-color: #ffb2b6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 2em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  position: relative;
  padding-left: 3.5em;
}
.desk-header .pagos-cont .first-cont .txt-cont .txt:nth-child(1) {
  font-size: 1.1em;
  font-weight: 100;
}
.desk-header .pagos-cont .first-cont .txt-cont .txt:nth-child(2) {
  font-size: 1.1em;
  font-weight: 900;
}
.desk-header .pagos-cont .first-cont .txt-cont .trokita {
  position: absolute;
  background-color: #ffb2b6;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.5em;
  left: -0.2em;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.desk-header .pagos-cont .second-cont {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.7em;
}
.desk-header .pagos-cont .second-cont .prin {
  background-color: #ffb2b6;
  font-size: 1em;
  font-weight: 600;
  padding: 0.2em 0.75em;
  border-radius: 2em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.desk-header .pagos-cont .second-cont .secon {
  font-size: 1em;
  font-weight: 100;
  width: 19em;
  text-align: center;
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1411764706);
}
.desk-header .pagos-cont .third-cont {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.4em;
}
.desk-header .pagos-cont .third-cont .prin {
  background-color: #ffb2b6;
  font-size: 1em;
  font-weight: 600;
  padding: 0.2em 0.75em;
  border-radius: 2em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.desk-header .pagos-cont .third-cont .contcarmov {
  width: 12em;
  height: 3.5em;
  position: relative;
  overflow: hidden;
}
.desk-header .pagos-cont .third-cont .contcarmov .mov {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4em;
  position: absolute;
  left: 14em;
  animation: mov 15s linear infinite;
}
.desk-header .pagos-cont .third-cont .contcarmov .mov .metodo-cont {
  width: 10em;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
}
.desk-header .pagos-cont .third-cont .contcarmov .mov .metodo-cont .grap {
  font-size: 2em;
}
.desk-header .pagos-cont .third-cont .contcarmov .mov .metodo-cont .txt {
  font-size: 0.6em;
  text-align: center;
  font-weight: 100;
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5098039216);
}
@keyframes mov {
  0% {
    left: 12em;
  }
  100% {
    left: -55em;
  }
}
.desk-header .up {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 1em 1em;
  border-bottom: 1px solid #1ca3c9;
  border-bottom-style: dashed;
  background-color: #fff;
  position: relative;
}
.desk-header .up .loguin {
  width: 9em;
  height: auto;
}
.desk-header .up .nav-opcs-cont {
  width: 50%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: 0.4em;
}
.desk-header .up .nav-opcs-cont .opi {
  margin-right: 1em;
  text-decoration: none;
  font-weight: 100;
  font-size: 0.9em;
  color: #777;
  position: relative;
  z-index: 1;
  cursor: pointer;
}
.desk-header .up .nav-opcs-cont .opi::before {
  content: "";
  width: 110%;
  height: 2em;
  background-color: #00a8cc;
  position: absolute;
  top: -1.2em;
  visibility: hidden;
  opacity: 0;
  left: -5%;
  z-index: -1;
  transition: 0.1s all ease-in-out;
  border-radius: 0.1em;
}
.desk-header .up .nav-opcs-cont .opi:hover {
  color: #fff;
}
.desk-header .up .nav-opcs-cont .opi:hover::before {
  top: -0.5em;
  visibility: visible;
  opacity: 1;
}
.desk-header .up .nav-opcs-cont .opi:last-child {
  margin-right: 0em;
}
.desk-header .up .nav-opcs-cont .tagin-mesrosa {
  background-color: #fdb6ff;
  border-radius: 2em;
  padding: 0.2em 1em;
  color: #fff;
}
.desk-header .up .nav-opcs-cont .tagin-mesrosa::before {
  content: "";
  display: none;
}
.desk-header .up .nav-opcs-cont .tagin-halloween {
  background-color: #e16216;
  border-radius: 2em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.2em 1em;
  gap: 0.5em;
  color: #fff;
}
.desk-header .up .nav-opcs-cont .tagin-halloween .grap {
  font-size: 1em;
}
.desk-header .up .nav-opcs-cont .tagin-halloween::before {
  content: "";
  display: none;
}
.desk-header .up .nav-cont {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.3em;
  position: relative;
  padding-left: 9em;
  display: none;
}
.desk-header .up .nav-cont .tagin-conts {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5em;
}
.desk-header .up .nav-cont .tagin-conts .tagin-mesrosa {
  background-color: #fdb6ff;
  border-radius: 2em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.2em 1em;
  gap: 0.5em;
  cursor: pointer;
}
.desk-header .up .nav-cont .tagin-conts .tagin-mesrosa .grap {
  font-size: 1em;
}
.desk-header .up .nav-cont .tagin-conts .tagin-mesrosa .tag-txt {
  font-size: 0.9em;
}
.desk-header .up .nav-cont .tagin-conts .tagin-halloween {
  background-color: #e16216;
  border-radius: 2em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.2em 1em;
  gap: 0.5em;
  cursor: pointer;
}
.desk-header .up .nav-cont .tagin-conts .tagin-halloween .grap {
  font-size: 1em;
}
.desk-header .up .nav-cont .tagin-conts .tagin-halloween .tag-txt {
  font-size: 0.9em;
}
.desk-header .up .nav-cont .btn-nav {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 18em;
  height: 2.5em;
  overflow: hidden;
  border-radius: 2em;
  box-shadow: 0px 0px 15px 1px rgba(0, 167, 204, 0.1764705882);
}
.desk-header .up .nav-cont .btn-nav .cros1 {
  background-color: #00a8cc;
  width: 2em;
  height: 19em;
  transform: rotate(84deg);
  animation: rot1 3s linear infinite;
}
@keyframes rot1 {
  from {
    transform: rotate(84deg);
  }
  to {
    transform: rotate(444deg);
  }
}
.desk-header .up .nav-cont .btn-nav .blankin-cont {
  background-color: #fff;
  width: 17.8em;
  height: 2.4em;
  border-radius: 4em;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 2em;
  transition: 0.7s all ease-in-out;
}
.desk-header .up .nav-cont .btn-nav .blankin-cont .blankin-txt {
  color: #00a8cc;
  transition: 0.7s all ease-in-out;
}
.desk-header .up .nav-cont .btn-nav .blankin-cont .blankin-icon {
  color: #00a8cc;
  transition: 0.7s all ease-in-out;
}
.desk-header .up .nav-cont .btn-nav .blankin-cont:hover {
  background-color: #00a8cc;
}
.desk-header .up .nav-cont .btn-nav .blankin-cont:hover .blankin-txt {
  color: #fff;
}
.desk-header .up .nav-cont .btn-nav .blankin-cont:hover .blankin-icon {
  color: #fff;
}
.desk-header .up .nav-cont .btn-nav:hover .cros1 {
  display: none;
}
.desk-header .up .desp-cont {
  position: absolute;
  top: -25em;
  width: 80%;
  height: 23.5em;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 1em;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  padding: 1em;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s all ease-in-out;
}
.desk-header .up .desp-cont .fix {
  width: 100%;
  height: 100%;
  gap: 0.5em;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 0.5em;
}
.desk-header .up .desp-cont .fix .opc {
  width: 100%;
  height: 2.5em;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
  color: #00a8cc;
  border-radius: 2em;
  font-size: 0.8em;
  padding: 1.3em 0em;
  padding-left: 1em;
  border: 1px solid #00a8cc;
  cursor: pointer;
  transition: 0.7s all ease-in-out;
}
.desk-header .up .desp-cont .fix .opc:hover {
  color: #fff;
  background-color: #00a8cc;
}
.desk-header .up .desp-cont .fix::-webkit-scrollbar {
  width: 0.3em;
  background-color: transparent;
  height: 0.7em;
}
.desk-header .up .desp-cont .fix::-webkit-scrollbar-thumb {
  background-color: #00a3c7;
  width: 0.25em;
}
.desk-header .up .third-cont {
  width: 33%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1em;
}
.desk-header .up .third-cont .busc-cont {
  width: 18em;
  height: 2.5em;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 1em;
  border-radius: 3em;
  border: 1px solid #1ca3c9;
  background-color: #1ca3c9;
  position: relative;
  box-shadow: rgba(0, 163, 199, 0.3) 5px 5px, rgba(0, 163, 199, 0.2) 10px 10px, rgba(0, 163, 199, 0.1) 15px 15px;
}
.desk-header .up .third-cont .busc-cont .grapi {
  font-size: 0.9em;
}
.desk-header .up .third-cont .busc-cont .inp {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  padding: 0em 1em;
  overflow: hidden;
  font-size: 0.9em;
  font-weight: 100;
}
.desk-header .up .third-cont .busc-cont .inp::placeholder {
  color: rgb(240, 240, 240);
}
.desk-header .up .third-cont .busc-cont .inp:focus {
  outline: none;
}
.desk-header .up .third-cont .busc-cont .encontrados-cont-desk {
  z-index: 99;
  position: absolute;
  top: 3em;
  left: calc(50% - 13.5em);
  width: 22em;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 1em;
  overflow: hidden;
  padding: 1em;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
}
.desk-header .up .third-cont .busc-cont .encontrados-cont-desk .line-filter-desk {
  text-align: center;
  line-height: 20px;
  background: #00a3c7;
  margin-block-start: 0em;
  margin-block-end: 0em;
  border-radius: 2em;
  padding: 0.1em 0em;
  font-size: 0.9em;
  width: 100%;
}
.desk-header .up .third-cont .busc-cont .encontrados-cont-desk .search-container-desk {
  width: 100%;
  height: auto;
  max-height: 30vh;
  overflow-y: scroll;
}
.desk-header .up .third-cont .busc-cont .encontrados-cont-desk .search-container-desk::-webkit-scrollbar {
  width: 0.3em;
  background-color: transparent;
  height: 0.7em;
}
.desk-header .up .third-cont .busc-cont .encontrados-cont-desk .search-container-desk::-webkit-scrollbar-thumb {
  background-color: #00a3c7;
  width: 0.25em;
}
.desk-header .up .third-cont .oth-opts-cont {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1em;
  padding-top: 1.4em;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.1em;
  position: relative;
  cursor: pointer;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .grapi-up {
  color: #97989b;
  font-size: 1.6em;
  transition: 0.1s all ease-in-out;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .grapi-down {
  color: #97989b;
  transition: 0.1s all ease-in-out;
  font-size: 0.9em;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .opts-acount-cont {
  position: absolute;
  right: 0;
  top: 2.3em;
  min-width: 12em;
  height: auto;
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 11;
  background-color: #fff;
  border-radius: 0.6em;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .opts-acount-cont .opas {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  transition: 0.5s all ease-in-out;
  padding: 0.5em 0em;
  text-decoration: none;
  gap: 1em;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .opts-acount-cont .opas span {
  color: #666;
  font-size: 0.8em;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .opts-acount-cont .opas:hover {
  background-color: rgb(242, 242, 242);
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont .opts-acount-cont .opas:hover span {
  color: #00a3c7;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont:hover .grapi-up {
  color: #000;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont:hover .grapi-down {
  color: #000;
}
.desk-header .up .third-cont .oth-opts-cont .opt-cont:hover .opts-acount-cont {
  display: flex;
}
.desk-header .down {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 0.9em 1em;
  background-color: #fff;
}
.desk-header .down .horario {
  font-size: 0.9em;
  color: #666;
  display: flex;
  flex-direction: column;
}
.desk-header .down .cont-rs {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
}
.desk-header .down .cont-rs .redin {
  width: 2.5em;
  height: 2.5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  text-decoration: none;
  transition: 0.7s all ease-in-out;
}
.desk-header .down .cont-rs .redin i {
  font-size: 1.1em;
  transition: 0.7s all ease-in-out;
}
.desk-header .down .cont-rs .redin:nth-child(1) {
  box-shadow: rgba(0, 165, 200, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(1) i {
  color: rgb(130, 192, 205);
}
.desk-header .down .cont-rs .redin:nth-child(1):hover {
  background-color: rgb(0, 165, 200);
}
.desk-header .down .cont-rs .redin:nth-child(1):hover i {
  color: #fff;
}
.desk-header .down .cont-rs .redin:nth-child(2) {
  box-shadow: rgba(101, 191, 205, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(2) i {
  color: rgb(101, 191, 205);
}
.desk-header .down .cont-rs .redin:nth-child(2):hover {
  background-color: rgb(101, 191, 205);
}
.desk-header .down .cont-rs .redin:nth-child(2):hover i {
  color: #fff;
}
.desk-header .down .cont-rs .redin:nth-child(3) {
  box-shadow: rgba(140, 205, 205, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(3) i {
  color: rgb(140, 205, 205);
}
.desk-header .down .cont-rs .redin:nth-child(3):hover {
  background-color: rgb(140, 205, 205);
}
.desk-header .down .cont-rs .redin:nth-child(3):hover i {
  color: #fff;
}
.desk-header .down .cont-rs .redin:nth-child(4) {
  box-shadow: rgba(115, 183, 224, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(4) i {
  color: rgb(115, 183, 224);
}
.desk-header .down .cont-rs .redin:nth-child(4):hover {
  background-color: rgb(115, 183, 224);
}
.desk-header .down .cont-rs .redin:nth-child(4):hover i {
  color: #fff;
}
.desk-header .down .cont-rs .redin:nth-child(5) {
  box-shadow: rgba(243, 172, 177, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(5) i {
  color: rgb(243, 172, 177);
}
.desk-header .down .cont-rs .redin:nth-child(5):hover {
  background-color: rgb(243, 172, 177);
}
.desk-header .down .cont-rs .redin:nth-child(5):hover i {
  color: #fff;
}
.desk-header .down .cont-rs .redin:nth-child(6) {
  box-shadow: rgba(243, 165, 141, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(6) i {
  color: rgb(243, 165, 141);
}
.desk-header .down .cont-rs .redin:nth-child(6):hover {
  background-color: rgb(243, 165, 141);
}
.desk-header .down .cont-rs .redin:nth-child(6):hover i {
  color: #fff;
}
.desk-header .down .cont-rs .redin:nth-child(7) {
  box-shadow: rgba(182, 206, 220, 0.56) 0px 0px 12px;
}
.desk-header .down .cont-rs .redin:nth-child(7) i {
  color: rgb(182, 206, 220);
}
.desk-header .down .cont-rs .redin:nth-child(7):hover {
  background-color: rgb(182, 206, 220);
}
.desk-header .down .cont-rs .redin:nth-child(7):hover i {
  color: #fff;
}
.desk-header .down .infocont {
  width: 20%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 0.2em;
}
.desk-header .down .infocont .opc {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  transition: 0.5s all ease-in-out;
  gap: 1em;
  width: 100%;
}
.desk-header .down .infocont .opc span {
  padding: 0em 0em;
  color: #777;
  font-size: 0.9em;
}
.desk-header .down .info-cont {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16em;
  height: 2.5em;
  box-shadow: rgba(0, 163, 199, 0.14) 0px 1px 12px;
  transition: 0.5s all ease-in-out;
  display: none;
}
.desk-header .down .info-cont span {
  color: #198aa3;
  font-size: 0.9em;
  font-weight: 100;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0em 2em;
  transition: 0.5s all ease-in-out;
}
.desk-header .down .info-cont .opcs-cont {
  position: absolute;
  top: 2.5em;
  width: 100%;
  height: auto;
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 1em;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.desk-header .down .info-cont .opcs-cont .opc {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  transition: 0.5s all ease-in-out;
  width: 100%;
  height: auto;
  padding: 0.7em 1em;
  gap: 1em;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 163, 199, 0.1490196078);
}
.desk-header .down .info-cont .opcs-cont .opc span {
  padding: 0em 0em;
  color: #198aa3;
}
.desk-header .down .info-cont .opcs-cont .opc:last-child {
  border-bottom: none;
}
.desk-header .down .info-cont .opcs-cont .opc:hover {
  background-color: rgb(240, 240, 240);
}
.desk-header .down .info-cont:hover {
  background-color: #1ca3c9;
}
.desk-header .down .info-cont:hover span {
  color: #fff;
}
.desk-header .down .info-cont:hover .opcs-cont {
  display: flex;
}

#scroll-text {
  /* animation properties */
  font-size: 20px;
  font-weight: bold;
  transform: translateX(10%);
  animation: my-animation 5s linear infinite;
}

/* for Firefox */
/* for Chrome */
@keyframes my-animation {
  from {
    transform: translateX(10%);
  }
  to {
    transform: translateX(-5%);
  }
}
.search_toggle {
  width: 100%;
  height: 100%;
}
.search_toggle #axbody {
  max-height: none !important;
  min-height: 100% !important;
  list-style: none;
  overflow-y: scroll !important;
  width: 100% !important;
  height: 20em;
  padding-inline-start: 0px;
  padding: 0em 1em;
  /*.ui-corner-all:last-child{
    border-bottom: none;
    margin-bottom: none;
  }*/
}
.search_toggle #axbody .ui-corner-all {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  border-bottom: 1px solid #00d7ff;
  border-bottom-style: dashed;
  padding-bottom: 0.75em;
  margin-bottom: 1em;
}
.search_toggle #axbody .search_lewa {
  display: block;
  width: 5em;
  height: 5em;
  border: 1px solid #00d3ff;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}
.search_toggle #axbody .search_lewa img {
  width: 100%;
  height: 100%;
}
.search_toggle #axbody .search_prawa {
  width: calc(100% - 6em);
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.36em;
}
.search_toggle #axbody .search_prawa .search_marka {
  color: #fff;
  font-weight: 100;
  font-size: 0.7em;
}
.search_toggle #axbody .search_prawa .search_nazwa {
  font-size: 0.85em;
  color: #fff;
  font-weight: 400;
}
.search_toggle #axbody .search_prawa .search_cena {
  font-size: 0.9em;
  color: #fff;
  font-weight: 100;
}
.search_toggle ul::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}
.search_toggle ul::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7176470588);
  width: 0.25em;
}
.search_toggle #search_plugin {
  width: 100%;
  height: 100%;
}
.search_toggle #search_plugin form {
  width: 100%;
  height: 100%;
}
.search_toggle #search_plugin form .buscainp {
  width: 100%;
  height: 100%;
  padding: 0em 1em;
  border-radius: 0em 3em 3em 0em;
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 0.9em;
}
.search_toggle #search_plugin form .buscainp:focus {
  outline: none;
}
.search_toggle #search_plugin form .buscainp::placeholder {
  color: rgba(255, 255, 255, 0.671);
  font-size: 0.8em;
}
.search_toggle .conten-abs {
  position: absolute;
  min-width: 40em;
  height: auto;
  top: 3em;
  right: 0;
  z-index: 10;
  background-color: #00a3c7;
  padding: 1em;
  border-radius: 2em;
}
.search_toggle .conten-abs .cuerpoPistas .txt-decir {
  margin: 0;
  margin-bottom: 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em;
  font-weight: 100;
  cursor: pointer;
}
.search_toggle .conten-abs .cuerpoPistas .ud1 {
  font-size: 0.6em;
  margin-left: 1em;
  color: #fff;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas {
  width: 100%;
  max-height: 8em;
  background-color: #0096b5;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5em;
  padding: 1em;
  overflow-y: scroll;
  border-radius: 2em 0em 0em 2em;
  transition: 0.2s all ease-in-out;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7176470588);
  width: 0.25em;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas div {
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
  padding: 5px 10px;
  color: #00d9ff;
  border: 1px dashed #00d3ff;
  margin: 3px;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.6s all ease-in-out;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas div:hover {
  color: #ffffff;
  border: 1px dashed #ffffff;
}
.search_toggle .conten-abs .dowi {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
}
.search_toggle .conten-abs .dowi .lefti {
  width: 40%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.3em;
}
.search_toggle .conten-abs .dowi .lefti .card {
  width: 100%;
  height: 3em;
  background-color: #0096b2;
  padding: 0.1em;
  border-radius: 0.5em;
  transition: 0.2s all ease-in-out;
  overflow: hidden;
}
.search_toggle .conten-abs .dowi .lefti .card .lista {
  overflow-y: scroll;
  width: 100%;
  height: 9em;
}
.search_toggle .conten-abs .dowi .lefti .card .lista::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}
.search_toggle .conten-abs .dowi .lefti .card .lista::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7176470588);
  width: 0.25em;
}
.search_toggle .conten-abs .dowi .lefti .card .lista div {
  position: relative;
  border-bottom: 1px solid #ffffff !important;
  width: 100%;
  height: 2.5em;
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 0.9em;
  font-weight: 100;
}
.search_toggle .conten-abs .dowi .lefti .card .lista div input[type=checkbox] {
  cursor: pointer;
  width: 1.2em;
  height: 1.2em;
}
.search_toggle .conten-abs .dowi .lefti .card .taitl-filt {
  text-align: center;
  cursor: pointer;
  color: #fff;
  font-size: 0.9em;
  font-weight: 100;
}
.search_toggle .conten-abs .dowi .lefti .card .taitl-filt i {
  font-size: 0.7em;
  color: #fff;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree {
  overflow-y: unset !important;
  padding: 0em 0em;
  margin-block-start: 0em;
  margin-block-end: 0em;
  height: auto;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree .less {
  height: auto !important;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree .less div {
  border-bottom: none;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree .less .w-100 {
  overflow-y: unset !important;
}
.search_toggle .conten-abs .dowi .rigti {
  width: 60%;
  height: auto;
  height: 25em;
  background-color: #0096b3;
  border-radius: 2em;
}
.search_toggle .conten-abs .dowi .rigti .result-taitl {
  color: #fff;
  font-size: 1em;
  font-weight: 100;
}`, "",{"version":3,"sources":["webpack://./src/app/components/desk-header/desk-header.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,qDAAA;EACA,sBAAA;EACA,WAAA;AACJ;AACI;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AACN;AACM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACR;AACQ;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wFAAA;EACA,kBAAA;EACA,mBAAA;AACV;AACU;EACE,gBAAA;EACA,gBAAA;AACZ;AAEU;EACE,gBAAA;EACA,gBAAA;AAAZ;AAGU;EACE,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,qDAAA;AADZ;AAMM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAJR;AAMQ;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wFAAA;AAJV;AAOQ;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oDAAA;AALV;AASM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAPR;AASQ;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wFAAA;AAPV;AAUQ;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AARV;AAUU;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,kCAAA;AARZ;AAUY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AARd;AAWc;EACE,cAAA;AAThB;AAYc;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AAVhB;AAeU;EACI;IACI,UAAA;EAbhB;EAgBY;IACI,WAAA;EAdhB;AACF;AAoBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;AAlBN;AAoBM;EACE,UAAA;EACA,YAAA;AAlBR;AAqBM;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAnBR;AAqBQ;EACE,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EAEA,kBAAA;EACA,UAAA;EACA,eAAA;AApBV;AAuBQ;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;AArBV;AAwBQ;EAEE,WAAA;AAvBV;AA0BQ;EACE,WAAA;EACA,mBAAA;EACA,UAAA;AAxBV;AA2BQ;EACE,iBAAA;AAzBV;AA4BQ;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA1BV;AA6BQ;EACE,WAAA;EACA,aAAA;AA3BV;AA8BQ;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AA5BV;AA8BU;EACE,cAAA;AA5BZ;AAgCQ;EACE,WAAA;EACA,aAAA;AA9BV;AAkCM;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;AAhCR;AAkCQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;AAhCV;AAkCU;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAhCZ;AAkCY;EACE,cAAA;AAhCd;AAmCY;EACE,gBAAA;AAjCd;AAqCU;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAnCZ;AAqCY;EACE,cAAA;AAnCd;AAsCY;EACE,gBAAA;AApCd;AAyCQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EAEA,4DAAA;AAxCV;AA0CU;EACE,yBAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;EACA,kCAAA;AAxCZ;AA2CU;EACE;IACE,wBAAA;EAzCZ;EA2CU;IACE,yBAAA;EAzCZ;AACF;AA4CU;EACE,sBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,gCAAA;AA1CZ;AA4CY;EACE,cAAA;EACA,gCAAA;AA1Cd;AA6CY;EACE,cAAA;EACA,gCAAA;AA3Cd;AA+CU;EACE,yBAAA;AA7CZ;AA+CY;EACE,WAAA;AA7Cd;AAgDY;EACE,WAAA;AA9Cd;AAoDU;EACE,aAAA;AAlDZ;AAuDM;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,sFAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;AArDR;AAuDQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,oBAAA;AArDV;AAuDU;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gCAAA;AArDZ;AAwDU;EACE,WAAA;EACA,yBAAA;AAtDZ;AA0DQ;EACE,YAAA;EACA,6BAAA;EACA,aAAA;AAxDV;AA2DQ;EACE,yBAAA;EAEA,aAAA;AA1DV;AA8DM;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AA5DR;AA8DQ;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8GACE;AA7DZ;AAiEU;EACE,gBAAA;AA/DZ;AAkEU;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAhEZ;AAmEU;EACE,yBAAA;AAjEZ;AAoEU;EACE,aAAA;AAlEZ;AAqEU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,wBAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;AAnEZ;AAqEY;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAnEd;AAsEY;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AApEd;AAuEY;EACE,YAAA;EACA,6BAAA;EACA,aAAA;AArEd;AAwEY;EACE,yBAAA;EAEA,aAAA;AAvEd;AA4EQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA1EV;AA4EU;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AA1EZ;AA4EY;EACE,cAAA;EACA,gBAAA;EACA,gCAAA;AA1Ed;AA6EY;EACE,cAAA;EACA,gCAAA;EACA,gBAAA;AA3Ed;AA8EY;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sFAAA;AA5Ed;AA8Ec;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;AA5EhB;AA8EgB;EACE,WAAA;EACA,gBAAA;AA5ElB;AAgFc;EACE,oCAAA;AA9EhB;AAgFgB;EACE,cAAA;AA9ElB;AAqFY;EACE,WAAA;AAnFd;AAsFY;EACE,WAAA;AApFd;AAuFY;EACE,aAAA;AArFd;AA4FI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AA1FN;AA4FM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AA1FR;AA6FM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AA3FR;AA6FQ;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;AA3FV;AA6FU;EACE,gBAAA;EACA,gCAAA;AA3FZ;AA+FQ;EACE,gDAAA;AA7FV;AA+FU;EACE,yBAAA;AA7FZ;AAiGQ;EACE,kCAAA;AA/FV;AAiGU;EACE,WAAA;AA/FZ;AAmGQ;EACE,kDAAA;AAjGV;AAmGU;EACE,yBAAA;AAjGZ;AAqGQ;EACE,oCAAA;AAnGV;AAqGU;EACE,WAAA;AAnGZ;AAuGQ;EACE,kDAAA;AArGV;AAuGU;EACE,yBAAA;AArGZ;AAyGQ;EACE,oCAAA;AAvGV;AAyGU;EACE,WAAA;AAvGZ;AA2GQ;EACE,kDAAA;AAzGV;AA2GU;EACE,yBAAA;AAzGZ;AA6GQ;EACE,oCAAA;AA3GV;AA6GU;EACE,WAAA;AA3GZ;AA+GQ;EACE,kDAAA;AA7GV;AA+GU;EACE,yBAAA;AA7GZ;AAiHQ;EACE,oCAAA;AA/GV;AAiHU;EACE,WAAA;AA/GZ;AAmHQ;EACE,kDAAA;AAjHV;AAmHU;EACE,yBAAA;AAjHZ;AAqHQ;EACE,oCAAA;AAnHV;AAqHU;EACE,WAAA;AAnHZ;AAuHQ;EACE,kDAAA;AArHV;AAuHU;EACE,yBAAA;AArHZ;AAyHQ;EACE,oCAAA;AAvHV;AAyHU;EACE,WAAA;AAvHZ;AA4HM;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;AA1HR;AA4HQ;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,QAAA;EACA,WAAA;AA1HV;AA4HU;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AA1HZ;AA+HM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gDAAA;EAGA,gCAAA;EACA,aAAA;AA/HR;AAiIQ;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AA/HV;AAkIQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,qDAAA;AAhIV;AAkIU;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,wDAAA;AAhIZ;AAkIY;EACE,gBAAA;EACA,cAAA;AAhId;AAoIU;EACE,mBAAA;AAlIZ;AAqIU;EACE,oCAAA;AAnIZ;AAwIM;EACE,yBAAA;AAtIR;AAwIQ;EACE,WAAA;AAtIV;AAyIQ;EACE,aAAA;AAvIV;;AA6IA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EAGA,0BAAA;EAIA,0CAAA;AA3IF;;AA8IA,gBAAA;AAMA,eAAA;AAMA;EACE;IAGE,0BAAA;EArIF;EAuIA;IAGE,0BAAA;EArIF;AACF;AAwIA;EACE,WAAA;EACA,YAAA;AAtIF;AAwIE;EACE,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EAeA;;;IAAA;AAjJJ;AAoII;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;AAlIN;AA0II;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;AAxIN;AA0IM;EACE,WAAA;EACA,YAAA;AAxIR;AA4II;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;AA1IN;AA4IM;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AA1IR;AA6IM;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AA3IR;AA8IM;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AA5IR;AAiJE;EACE,aAAA;EACA,6BAAA;EACA,aAAA;AA/IJ;AAkJE;EACE,mDAAA;EAEA,aAAA;AAjJJ;AAoJE;EACE,WAAA;EACA,YAAA;AAlJJ;AAoJI;EACE,WAAA;EACA,YAAA;AAlJN;AAoJM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAlJR;AAqJM;EACE,aAAA;AAnJR;AAsJM;EACE,iCAAA;EACA,gBAAA;AApJR;AAyJE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAvJJ;AA2JM;EACE,SAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAzJR;AA4JM;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AA1JR;AA6JM;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;AA3JR;AA8JM;EACE,aAAA;EACA,6BAAA;EACA,aAAA;AA5JR;AA+JM;EACE,mDAAA;EAEA,aAAA;AA9JR;AAiKM;EACE,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AA/JR;AAkKM;EACE,cAAA;EACA,0BAAA;AAhKR;AAoKI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;AAlKN;AAoKM;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;AAlKR;AAoKQ;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,gBAAA;AAlKV;AAoKU;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAlKZ;AAqKU;EACE,aAAA;EACA,6BAAA;EACA,aAAA;AAnKZ;AAsKU;EACE,mDAAA;EAEA,aAAA;AArKZ;AAwKU;EACE,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAtKZ;AAwKY;EACE,eAAA;EACA,YAAA;EACA,aAAA;AAtKd;AA0KU;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAxKZ;AA0KY;EACE,gBAAA;EACA,WAAA;AAxKd;AA4KU;EACE,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AA1KZ;AA4KY;EACE,uBAAA;AA1Kd;AA4Kc;EACE,mBAAA;AA1KhB;AA6Kc;EACE,4BAAA;AA3KhB;AAkLM;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAhLR;AAkLQ;EACE,WAAA;EACA,cAAA;EACA,gBAAA;AAhLV","sourcesContent":[".desk-header{\r\n    width: calc(100%);\r\n    height: auto;\r\n    position: relative;\r\n    z-index: 10;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n    background-color: #fff;\r\n    color: #fff;\r\n  \r\n    .pagos-cont{\r\n      width: 100%;\r\n      height: 6em;\r\n      background-color: #ecd6d4;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: space-around;\r\n      align-items: center;\r\n  \r\n      .first-cont{\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n  \r\n        .txt-cont{\r\n          width: 20em;\r\n          height: 3.5em;\r\n          background-color: #ffb2b6;\r\n          display: flex;\r\n          flex-direction: column;\r\n          justify-content: center;\r\n          align-items: center;\r\n          border-radius: 2em;\r\n          box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\r\n          position: relative;\r\n          padding-left: 3.5em;\r\n  \r\n          .txt:nth-child(1){\r\n            font-size: 1.1em;\r\n            font-weight: 100;\r\n          }\r\n  \r\n          .txt:nth-child(2){\r\n            font-size: 1.1em;\r\n            font-weight: 900;\r\n          }\r\n  \r\n          .trokita{\r\n            position: absolute;\r\n            background-color: #ffb2b6;\r\n            width: 2em;\r\n            height: 2em;\r\n            border-radius: 50%;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            font-size: 2.5em;\r\n            left: -.2em;\r\n            box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n          }\r\n        }\r\n      }\r\n  \r\n      .second-cont{\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: .7em;\r\n  \r\n        .prin{\r\n          background-color: #ffb2b6;\r\n          font-size: 1em;\r\n          font-weight: 600;\r\n          padding: 0.2em 0.75em;\r\n          border-radius: 2em;\r\n          box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\r\n        }\r\n  \r\n        .secon{\r\n          font-size: 1em;\r\n          font-weight: 100;\r\n          width: 19em;\r\n          text-align: center;\r\n          text-shadow: 0px 0px 3px #00000024;\r\n        }\r\n      }\r\n  \r\n      .third-cont{\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: .4em;\r\n  \r\n        .prin{\r\n          background-color: #ffb2b6;\r\n          font-size: 1em;\r\n          font-weight: 600;\r\n          padding: 0.2em 0.75em;\r\n          border-radius: 2em;\r\n          box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\r\n        }\r\n  \r\n        .contcarmov{\r\n          width: 12em;\r\n          height: 3.5em;\r\n          position: relative;\r\n          overflow: hidden;\r\n       \r\n          .mov{\r\n            height: 100%;\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: flex-start;\r\n            align-items: center;\r\n            gap: 4em;\r\n            position: absolute;\r\n            left: 14em;\r\n            animation: mov 15s linear infinite;\r\n      \r\n            .metodo-cont{\r\n              width: 10em;\r\n              height: 100%;\r\n              display: flex;\r\n              flex-direction: column;\r\n              justify-content: center;\r\n              align-items: center;\r\n              gap: .5em;\r\n              //@at-root: 1px solid red;\r\n  \r\n              .grap{\r\n                font-size: 2em;\r\n              }\r\n  \r\n              .txt{\r\n                font-size: .6em;\r\n                text-align: center;\r\n                font-weight: 100;\r\n                text-shadow: 0px 0px 3px #00000082;\r\n              }\r\n            }\r\n          }\r\n       \r\n          @keyframes mov{\r\n              0%{\r\n                  left: 12em;\r\n              }\r\n       \r\n              100%{\r\n                  left: -55em;\r\n              }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    .up{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: space-around;\r\n      align-items: center;\r\n      padding: 1em 1em;\r\n      border-bottom: 1px solid #1ca3c9;\r\n      border-bottom-style: dashed;\r\n      background-color: #fff;\r\n      position: relative;\r\n  \r\n      .loguin{\r\n        width: 9em;\r\n        height: auto;\r\n      }\r\n\r\n      .nav-opcs-cont{\r\n        width: 50%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n        align-items: center;\r\n        row-gap: .4em;\r\n        \r\n        .opi{\r\n          margin-right: 1em;\r\n          text-decoration: none;\r\n          font-weight: 100;\r\n          font-size: .9em;\r\n          color: #777;\r\n          //transition: .2s all ease-in-out;\r\n          position: relative;\r\n          z-index: 1;\r\n          cursor: pointer;\r\n        }\r\n\r\n        .opi::before{\r\n          content: '';\r\n          width: 110%;\r\n          height: 2em;\r\n          background-color: #00a8cc;\r\n          position: absolute;\r\n          top: -1.2em; // .5em\r\n          visibility: hidden;\r\n          opacity: 0;\r\n          left: calc(50% - 55%);\r\n          z-index: -1;\r\n          transition: .1s all ease-in-out;\r\n          border-radius: .1em;\r\n        }\r\n\r\n        .opi:hover{\r\n          //font-size: 1em;\r\n          color: #fff;\r\n        }\r\n\r\n        .opi:hover::before{\r\n          top: -.5em; // .5em\r\n          visibility: visible;\r\n          opacity: 1;\r\n        }\r\n\r\n        .opi:last-child{\r\n          margin-right: 0em;\r\n        }\r\n\r\n        .tagin-mesrosa{\r\n          background-color: #fdb6ff;\r\n          border-radius: 2em;\r\n          padding: 0.2em 1em;\r\n          color: #fff;\r\n        }\r\n\r\n        .tagin-mesrosa::before{\r\n          content: '';\r\n          display: none;\r\n        }\r\n\r\n        .tagin-halloween{\r\n          background-color: #e16216;\r\n          border-radius: 2em;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: center;\r\n          align-items: center;\r\n          padding: 0.2em 1em;\r\n          gap: 0.5em;\r\n          color: #fff;\r\n  \r\n          .grap{\r\n            font-size: 1em;\r\n          }\r\n        }\r\n\r\n        .tagin-halloween::before{\r\n          content: '';\r\n          display: none;\r\n        }\r\n      }\r\n  \r\n      .nav-cont{\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        gap: .3em;\r\n        position: relative;\r\n        padding-left: 9em;\r\n        display: none;\r\n  \r\n        .tagin-conts{\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          gap: .5em;\r\n  \r\n          .tagin-mesrosa{\r\n            background-color: #fdb6ff;\r\n            border-radius: 2em;\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: center;\r\n            align-items: center;\r\n            padding: 0.2em 1em;\r\n            gap: 0.5em;\r\n            cursor: pointer;\r\n    \r\n            .grap{\r\n              font-size: 1em;\r\n            }\r\n    \r\n            .tag-txt{\r\n              font-size: .9em;\r\n            }\r\n          }\r\n    \r\n          .tagin-halloween{\r\n            background-color: #e16216;\r\n            border-radius: 2em;\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: center;\r\n            align-items: center;\r\n            padding: 0.2em 1em;\r\n            gap: 0.5em;\r\n            cursor: pointer;\r\n    \r\n            .grap{\r\n              font-size: 1em;\r\n            }\r\n    \r\n            .tag-txt{\r\n              font-size: .9em;\r\n            }\r\n          }\r\n        }\r\n  \r\n        .btn-nav{\r\n          position: relative;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: center;\r\n          align-items: center;\r\n          width: 18em;\r\n          height: 2.5em;\r\n          overflow: hidden;\r\n          border-radius: 2em;\r\n          //border: 1px solid red;\r\n          box-shadow: 0px 0px 15px 1px #00a7cc2d;\r\n        \r\n          .cros1{\r\n            background-color: #00a8cc;\r\n            width: 2em;\r\n            height: 19em;\r\n            transform: rotate(84deg);\r\n            animation: rot1 3s linear infinite;\r\n          }\r\n  \r\n          @keyframes rot1{\r\n            from{\r\n              transform: rotate(84deg);\r\n            }\r\n            to{\r\n              transform: rotate(444deg);\r\n            }\r\n          }\r\n  \r\n          .blankin-cont{\r\n            background-color: #fff;\r\n            width: 17.8em;\r\n            height: 2.4em;\r\n            border-radius: 4em;\r\n            position: absolute;\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: center;\r\n            align-items: center;\r\n            cursor: pointer;\r\n            gap: 2em;\r\n            transition: .7s all ease-in-out;\r\n  \r\n            .blankin-txt{\r\n              color: #00a8cc;\r\n              transition: .7s all ease-in-out;\r\n            }\r\n  \r\n            .blankin-icon{\r\n              color: #00a8cc;\r\n              transition: .7s all ease-in-out;\r\n            }\r\n          }\r\n  \r\n          .blankin-cont:hover{\r\n            background-color: #00a8cc;\r\n  \r\n            .blankin-txt{\r\n              color: #fff;\r\n            }\r\n  \r\n            .blankin-icon{\r\n              color: #fff;\r\n            }\r\n          }\r\n        }\r\n  \r\n        .btn-nav:hover{\r\n          .cros1{\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n  \r\n      .desp-cont{\r\n        position: absolute;\r\n        top: -25em;\r\n        width: 80%;\r\n        height: 23.5em;\r\n        background-color: #fff;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        border-radius: 1em;\r\n        box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\r\n        padding: 1em;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transition: .5s all ease-in-out;\r\n  \r\n        .fix{\r\n          width: 100%;\r\n          height: 100%;\r\n          gap: 0.5em;\r\n          overflow-y: scroll;\r\n          display: flex;\r\n          flex-direction: column;\r\n          justify-content: flex-start;\r\n          align-items: flex-start;\r\n          padding-right: .5em;\r\n  \r\n          .opc{\r\n            width: 100%;\r\n            height: 2.5em;\r\n            display: flex;\r\n            justify-content: flex-start;\r\n            align-items: center;\r\n            background-color: #fff;\r\n            color: #00a8cc;\r\n            border-radius: 2em;\r\n            font-size: 0.8em;\r\n            padding: 1.3em 0em;\r\n            padding-left: 1em;\r\n            border: 1px solid #00a8cc;\r\n            cursor: pointer;\r\n            transition: .7s all ease-in-out;\r\n          }\r\n  \r\n          .opc:hover{\r\n            color: #fff;\r\n            background-color: #00a8cc;\r\n          }\r\n        }\r\n  \r\n        .fix::-webkit-scrollbar {\r\n          width: .3em;\r\n          background-color: transparent;\r\n          height: .7em;\r\n        }\r\n      \r\n        .fix::-webkit-scrollbar-thumb {\r\n          background-color: #00a3c7;\r\n          //border-radius: 1vh;\r\n          width: 0.25em;\r\n        }\r\n      }\r\n\r\n      .third-cont{\r\n        width: 33%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 1em;\r\n\r\n        .busc-cont{\r\n          width: 18em;\r\n          height: 2.5em;\r\n          display: flex;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          padding-left: 1em;\r\n          border-radius: 3em;\r\n          border: 1px solid #1ca3c9;\r\n          background-color: #1ca3c9;\r\n          position: relative;\r\n          box-shadow: \r\n            rgba(0, 163, 199, 0.3) 5px 5px, \r\n            rgba(0, 163, 199, 0.2) 10px 10px, \r\n            rgba(0, 163, 199, 0.1) 15px 15px;\r\n\r\n          .grapi{\r\n            font-size: .9em;\r\n          }\r\n    \r\n          .inp{\r\n            width: 100%;\r\n            height: 100%;\r\n            background-color: transparent;\r\n            border: none;\r\n            padding: 0em 1em;\r\n            overflow: hidden;\r\n            font-size: .9em;\r\n            font-weight: 100;\r\n          }\r\n    \r\n          .inp::placeholder{\r\n            color: rgb(240, 240, 240);\r\n          }\r\n    \r\n          .inp:focus{\r\n            outline: none;\r\n          }\r\n    \r\n          .encontrados-cont-desk{\r\n            z-index: 99; \r\n            position: absolute; \r\n            top: 3em;\r\n            left: calc(50% - 13.5em);\r\n            width: 22em;\r\n            box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n            border-radius: 1em;\r\n            overflow: hidden;\r\n            padding: 1em;\r\n            background-color: #fff;  \r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: flex-start;\r\n            align-items: flex-start;\r\n            gap: 1em;\r\n    \r\n            .line-filter-desk{\r\n              text-align: center;\r\n              line-height: 20px;\r\n              background: #00a3c7;\r\n              margin-block-start: 0em;\r\n              margin-block-end: 0em;\r\n              border-radius: 2em;\r\n              padding: 0.1em 0em;\r\n              font-size: .9em;\r\n              width: 100%;\r\n            }\r\n    \r\n            .search-container-desk{\r\n              width: 100%;\r\n              height: auto;\r\n              max-height: 30vh;\r\n              overflow-y: scroll;\r\n            }\r\n    \r\n            .search-container-desk::-webkit-scrollbar {\r\n              width: .3em;\r\n              background-color: transparent;\r\n              height: .7em;\r\n            }\r\n          \r\n            .search-container-desk::-webkit-scrollbar-thumb {\r\n              background-color: #00a3c7;\r\n              //border-radius: 1vh;\r\n              width: 0.25em;\r\n            }\r\n          }\r\n        }\r\n\r\n        .oth-opts-cont{\r\n          width: auto;\r\n          height: auto;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: center;\r\n          align-items: center;\r\n          gap: 1em;\r\n          padding-top: 1.4em;\r\n\r\n          .opt-cont{\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: flex-start;\r\n            align-items: center;\r\n            gap: .1em;\r\n            position: relative;\r\n            cursor: pointer;\r\n\r\n            .grapi-up{\r\n              color: #97989b;\r\n              font-size: 1.6em;\r\n              transition: .1s all ease-in-out;\r\n            }\r\n\r\n            .grapi-down{\r\n              color: #97989b;\r\n              transition: .1s all ease-in-out;\r\n              font-size: .9em;\r\n            }\r\n\r\n            .opts-acount-cont{\r\n              position: absolute;\r\n              right: 0;\r\n              top: 2.3em;\r\n              min-width: 12em;\r\n              height: auto;\r\n              display: none;\r\n              flex-direction: column;\r\n              justify-content: flex-start;\r\n              align-items: flex-start;\r\n              z-index: 11;\r\n              background-color: #fff;\r\n              border-radius: 0.6em;\r\n              overflow: hidden;\r\n              box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\r\n\r\n              .opas{\r\n                width: 100%;\r\n                height: auto;\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                background-color: #ffff;\r\n                transition: .5s all ease-in-out;\r\n                padding: .5em 0em;\r\n                text-decoration: none;\r\n                gap: 1em;\r\n\r\n                span{\r\n                  color: #666;\r\n                  font-size: .8em;\r\n                }\r\n              }\r\n\r\n              .opas:hover{\r\n                background-color: rgb(242, 242, 242);\r\n\r\n                span{\r\n                  color: #00a3c7;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .opt-cont:hover{\r\n            .grapi-up{\r\n              color: #000;\r\n            }\r\n\r\n            .grapi-down{\r\n              color: #000;\r\n            }\r\n\r\n            .opts-acount-cont{\r\n              display: flex;\r\n            } \r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    .down{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: space-around;\r\n      align-items: center;\r\n      padding: .9em 1em;\r\n      background-color: #fff;\r\n  \r\n      .horario{\r\n        font-size: .9em;\r\n        color: #666;\r\n        display: flex;\r\n        flex-direction: column;\r\n      }\r\n  \r\n      .cont-rs{\r\n        width: auto;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: .5em;\r\n  \r\n        .redin{\r\n          width: 2.5em;\r\n          height: 2.5em;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: center;\r\n          align-items: center;\r\n          border-radius: 50%;\r\n          text-decoration: none;\r\n          transition: .7s all ease-in-out;\r\n  \r\n          i{\r\n            font-size: 1.1em;\r\n            transition: .7s all ease-in-out;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(1){\r\n          box-shadow: rgb(0 165 200 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(130 192 205 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(1):hover{\r\n          background-color: rgb(0 165 200 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(2){\r\n          box-shadow: rgb(101 191 205 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(101 191 205 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(2):hover{\r\n          background-color: rgb(101 191 205 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(3){\r\n          box-shadow: rgb(140 205 205 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(140 205 205 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(3):hover{\r\n          background-color: rgb(140 205 205 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(4){\r\n          box-shadow: rgb(115 183 224 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(115 183 224 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(4):hover{\r\n          background-color: rgb(115 183 224 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(5){\r\n          box-shadow: rgb(243 172 177 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(243 172 177 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(5):hover{\r\n          background-color: rgb(243 172 177 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(6){\r\n          box-shadow: rgb(243 165 141 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(243 165 141 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(6):hover{\r\n          background-color: rgb(243 165 141 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(7){\r\n          box-shadow: rgb(182 206 220 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(182 206 220 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(7):hover{\r\n          background-color: rgb(182 206 220 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n      }\r\n\r\n      .infocont{\r\n        width: 20%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-end;\r\n        gap: .2em;\r\n\r\n        .opc{\r\n          background-color: #fff;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: center;\r\n          align-items: center;\r\n          text-decoration: none;\r\n          transition: .5s all ease-in-out;\r\n          gap: 1em;\r\n          width: 100%;\r\n\r\n          span{\r\n            padding: 0em 0em;\r\n            color: #777;\r\n            font-size: .9em;\r\n          }\r\n        }\r\n      }\r\n  \r\n      .info-cont{\r\n        position: relative;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        width: 16em;\r\n        height: 2.5em;\r\n        box-shadow: rgb(0 163 199 / 14%) 0px 1px 12px;\r\n        //border-radius: 2em;\r\n        //border-bottom: 1px solid rgb(0 163 199 / 20%);\r\n        transition: .5s all ease-in-out;\r\n        display: none;\r\n  \r\n        span{\r\n          color: #198aa3;\r\n          font-size: .9em;\r\n          font-weight: 100;\r\n          display: flex;\r\n          justify-content: space-between;\r\n          width: 100%;\r\n          padding: 0em 2em;\r\n          transition: .5s all ease-in-out;\r\n        }\r\n  \r\n        .opcs-cont{\r\n          position: absolute;\r\n          top: 2.5em;\r\n          width: 100%;\r\n          height: auto;\r\n          display: none;\r\n          flex-direction: column;\r\n          justify-content: flex-start;\r\n          align-items: flex-start;\r\n          padding-top: 1em;\r\n          box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n  \r\n          .opc{\r\n            background-color: #fff;\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: flex-start;\r\n            align-items: center;\r\n            text-decoration: none;\r\n            transition: .5s all ease-in-out;\r\n            width: 100%;\r\n            height: auto;\r\n            padding: 0.7em 1em;\r\n            gap: 1em;\r\n            cursor: pointer;\r\n            border-bottom: 1px solid #00a3c726;\r\n  \r\n            span{\r\n              padding: 0em 0em;\r\n              color: #198aa3;\r\n            }\r\n          }\r\n  \r\n          .opc:last-child{\r\n            border-bottom: none;\r\n          }\r\n  \r\n          .opc:hover{\r\n            background-color: rgb(240, 240, 240);\r\n          }\r\n        }\r\n      }\r\n  \r\n      .info-cont:hover{\r\n        background-color: #1ca3c9;\r\n  \r\n        span{\r\n          color: #fff;\r\n        }\r\n  \r\n        .opcs-cont{\r\n          display: flex;\r\n        }\r\n      }\r\n    }\r\n}\r\n\r\n#scroll-text {\r\n  /* animation properties */\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  -moz-transform: translateX(10%);\r\n  -webkit-transform: translateX(10%);\r\n  transform: translateX(10%);\r\n  \r\n  -moz-animation: my-animation 5s linear infinite;\r\n  -webkit-animation: my-animation 5s linear infinite;\r\n  animation: my-animation 5s linear infinite;\r\n}\r\n\r\n/* for Firefox */\r\n@-moz-keyframes my-animation {\r\n  from { -moz-transform: translateX(10%); }\r\n  to { -moz-transform: translateX(-5%); }\r\n}\r\n\r\n/* for Chrome */\r\n@-webkit-keyframes my-animation {\r\n  from { -webkit-transform: translateX(10%); }\r\n  to { -webkit-transform: translateX(-5%); }\r\n}\r\n\r\n@keyframes my-animation {\r\n  from {\r\n    -moz-transform: translateX(10%);\r\n    -webkit-transform: translateX(10%);\r\n    transform: translateX(10%);\r\n  }\r\n  to {\r\n    -moz-transform: translateX(-5%);\r\n    -webkit-transform: translateX(-5%);\r\n    transform: translateX(-5%);\r\n  }\r\n}\r\n\r\n.search_toggle{\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  #axbody{\r\n    max-height: none!important;\r\n    min-height: 100% !important;\r\n    list-style: none;\r\n    overflow-y: scroll!important;\r\n    width: 100%!important;\r\n    height: 20em;\r\n    padding-inline-start: 0px;\r\n    padding: 0em 1em;\r\n\r\n    .ui-corner-all{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      justify-content: flex-start;\r\n      align-items: center;\r\n      gap: 1em;\r\n      border-bottom: 1px solid #00d7ff;\r\n      border-bottom-style: dashed;\r\n      padding-bottom: 0.75em;\r\n      margin-bottom: 1em;\r\n    }\r\n\r\n    /*.ui-corner-all:last-child{\r\n      border-bottom: none;\r\n      margin-bottom: none;\r\n    }*/\r\n\r\n    .search_lewa{\r\n      display: block;\r\n      width: 5em;\r\n      height: 5em;\r\n      border: 1px solid #00d3ff;\r\n      border-radius: 50%;\r\n      background-position: center;\r\n      background-size: cover;\r\n      overflow: hidden;\r\n\r\n      img{\r\n        width: 100%;\r\n        height: 100%;\r\n      }\r\n    }\r\n\r\n    .search_prawa{\r\n      width: calc(100% - 6em);\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      align-items: flex-start;\r\n      gap: 0.36em;\r\n\r\n      .search_marka{\r\n        color: #fff;\r\n        font-weight: 100;\r\n        font-size: .7em;\r\n      }\r\n\r\n      .search_nazwa{\r\n        font-size: .85em;\r\n        color: #fff;\r\n        font-weight: 400;\r\n      }\r\n\r\n      .search_cena{\r\n        font-size: .9em;\r\n        color: #fff;\r\n        font-weight: 100;\r\n      }\r\n    }\r\n  }\r\n\r\n  ul::-webkit-scrollbar {\r\n    width: .35em;\r\n    background-color: transparent;\r\n    height: .7em;\r\n  }\r\n    \r\n  ul::-webkit-scrollbar-thumb {\r\n    background-color: #ffffffb7;\r\n    //border-radius: 1vh;\r\n    width: 0.25em;\r\n  }\r\n\r\n  #search_plugin{\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    form{\r\n      width: 100%;\r\n      height: 100%;\r\n\r\n      .buscainp{\r\n        width: 100%;\r\n        height: 100%;\r\n        padding: 0em 1em;\r\n        border-radius: 0em 3em 3em 0em;\r\n        background-color: transparent;\r\n        border: none;\r\n        color: #fff;\r\n        font-size: .9em;\r\n      }\r\n\r\n      .buscainp:focus{\r\n        outline: none;\r\n      }\r\n\r\n      .buscainp::placeholder{\r\n        color: rgba(255, 255, 255, 0.671);\r\n        font-size: .8em;\r\n      }\r\n    }\r\n  }\r\n\r\n  .conten-abs{\r\n    position: absolute;\r\n    min-width: 40em;\r\n    height: auto;\r\n    top: 3em;\r\n    right: 0;\r\n    z-index: 10;\r\n    background-color: #00a3c7;\r\n    padding: 1em;\r\n    border-radius: 2em;\r\n\r\n    .cuerpoPistas{\r\n\r\n      .txt-decir{\r\n        margin: 0;\r\n        margin-bottom: 0.5em;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        font-size: 1.4em;\r\n        font-weight: 100;\r\n        cursor: pointer;\r\n      }\r\n\r\n      .ud1{\r\n        font-size: .6em;\r\n        margin-left: 1em;\r\n        color: #fff;\r\n      }\r\n\r\n      .lasPistas{\r\n        width: 100%;\r\n        max-height: 8em;\r\n        background-color: #0096b5;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n        gap: .5em;\r\n        padding: 1em;\r\n        overflow-y: scroll;\r\n        border-radius: 2em 0em 0em 2em;\r\n        transition: .2s all ease-in-out;\r\n      }\r\n\r\n      .lasPistas::-webkit-scrollbar {\r\n        width: .35em;\r\n        background-color: transparent;\r\n        height: .7em;\r\n      }\r\n        \r\n      .lasPistas::-webkit-scrollbar-thumb {\r\n        background-color: #ffffffb7;\r\n        //border-radius: 1vh;\r\n        width: 0.25em;\r\n      }\r\n\r\n      .lasPistas div{\r\n        width: fit-content;\r\n        display: inline-block;\r\n        padding: 5px 10px;\r\n        color: #00d9ff;\r\n        border: 1px dashed #00d3ff;\r\n        margin: 3px;\r\n        border-radius: 3px;\r\n        cursor: pointer;\r\n        transition: .6s all ease-in-out;\r\n      }\r\n\r\n      .lasPistas div:hover{\r\n        color: #ffffff;\r\n        border: 1px dashed #ffffff;\r\n      }\r\n    }\r\n\r\n    .dowi{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: flex-start;\r\n      align-items: flex-start;\r\n      gap: 1em;\r\n\r\n      .lefti{\r\n        width: 40%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        gap: 0.3em;\r\n\r\n        .card{\r\n          width: 100%;\r\n          height: 3em;\r\n          background-color: #0096b2;\r\n          padding: 0.1em;\r\n          border-radius: 0.5em;\r\n          transition: .2s all ease-in-out;\r\n          overflow: hidden;\r\n\r\n          .lista{\r\n            overflow-y: scroll;\r\n            width: 100%;\r\n            height: 9em;\r\n          }\r\n\r\n          .lista::-webkit-scrollbar {\r\n            width: .35em;\r\n            background-color: transparent;\r\n            height: .7em;\r\n          }\r\n            \r\n          .lista::-webkit-scrollbar-thumb {\r\n            background-color: #ffffffb7;\r\n            //border-radius: 1vh;\r\n            width: 0.25em;\r\n          }\r\n\r\n          .lista div{\r\n            position: relative;\r\n            border-bottom: 1px solid #ffffff!important;\r\n            width: 100%;\r\n            height: 2.5em;\r\n            display: flex!important;\r\n            flex-direction: row;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            color: #fff;\r\n            font-size: .9em;\r\n            font-weight: 100;\r\n\r\n            input[type='checkbox']{\r\n              cursor: pointer;\r\n              width: 1.2em;\r\n              height: 1.2em;\r\n            }\r\n          }\r\n\r\n          .taitl-filt{\r\n            text-align: center;\r\n            cursor: pointer;\r\n            color: #fff;\r\n            font-size: .9em;\r\n            font-weight: 100;\r\n\r\n            i{\r\n              font-size: .7em;\r\n              color: #fff;\r\n            }\r\n          }\r\n\r\n          .category-tree{\r\n            overflow-y: unset!important;\r\n            padding: 0em 0em;\r\n            margin-block-start: 0em;\r\n            margin-block-end: 0em;\r\n            height: auto;\r\n\r\n            .less{\r\n              height: auto!important;\r\n\r\n              div{\r\n                border-bottom: none;\r\n              }\r\n\r\n              .w-100{\r\n                overflow-y: unset!important;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .rigti{\r\n        width: 60%;\r\n        height: auto;\r\n        height: 25em;\r\n        background-color: #0096b3;\r\n        border-radius: 2em;\r\n\r\n        .result-taitl{\r\n          color: #fff;\r\n          font-size: 1em;\r\n          font-weight: 100;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media(max-width: 992px){\r\n  \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
